import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sessionId = hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) { navigate("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: data } });
      } catch {
        navigate("/login?error=1");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="bg-[#050505] min-h-screen flex flex-col items-center justify-center gap-4">
      <Loader2 className="animate-spin text-[var(--accent)]" size={40} />
      <p className="font-mono text-xs uppercase tracking-widest text-[var(--text-secondary)]">Signing you in…</p>
    </div>
  );
}
